import {
  ELMA365ToolsetAvailability,
  ELMA365ToolsetModel,
  ELMA365VersionAction,
  ELMA365ToolsetStatus,
  ELMA365ToolsetVisibility,
  ELMA365VersionAvailability,
  ELMA365VersionModel,
  ELMA365VersionPhase,
  ELMA365VersionStage,
  ELMA365VersionStatus,
  ELMA365VersionVisibility,
} from '../../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'elma365-toolset-modal';
export const FORM_ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__form-item`;
export const CONNECTORS_BUTTON_CLASS_NAME = `${FORM_ITEM_CLASS_NAME}__connectors-button`;

export const INITIAL_MODAL_WIDTH = 896;
export const DEFAULT_MODAL_WIDTH = '75%';

export const EMPTY_TOOLSET: ELMA365ToolsetModel = {
  toolset_id: '',
  folder_id: '',
  connector_id: '',
  version_id: '',
  status: ELMA365ToolsetStatus.Empty,
  visibility: ELMA365ToolsetVisibility.Visible,
  availability: ELMA365ToolsetAvailability.Enabled,
  namespaces: [],
  volume: {},
  code: '',
  name: '',
};

export const EMPTY_CREATION_VERSION: ELMA365VersionModel = {
  version_id: '',
  folder_id: '',
  connector_id: '',
  toolset_id: '',
  action: ELMA365VersionAction.Creation,
  status: ELMA365VersionStatus.Empty,
  stage: ELMA365VersionStage.Connector,
  phase: ELMA365VersionPhase.Pending,
  availability: ELMA365VersionAvailability.Enabled,
  visibility: ELMA365VersionVisibility.Visible,
  name: '',
  scheme: { etag: '' },
  problem: null,
};

export const EMPTY_APPENDING_VERSION: ELMA365VersionModel = {
  version_id: '',
  folder_id: '',
  connector_id: '',
  toolset_id: '',
  action: ELMA365VersionAction.Appending,
  status: ELMA365VersionStatus.Empty,
  stage: ELMA365VersionStage.Connector,
  phase: ELMA365VersionPhase.Pending,
  availability: ELMA365VersionAvailability.Enabled,
  visibility: ELMA365VersionVisibility.Visible,
  name: '',
  scheme: { etag: '' },
  problem: null,
};
